export default "__VITE_ASSET__B1W7glvw__"